const TradingNavButton = ({
  name,
  currentTab = false,
  onClick
}: {
  name: string
  currentTab?: boolean
  onClick?: () => void
}) => {
  return (
    <button
      className={`px-6 py-2.5 h-10 w-min-29 text-sm font-semibold ${
        currentTab
          ? 'dark:bg-transparent primary-gradient-border-pseudo rounded-2xl'
          : 'bg-card text-text-secondary rounded-full dark:border-0 border border-border-base'
      }`}
      onClick={onClick}
    >
      <span className={currentTab ? 'primary-gradient-text' : ''}>{name}</span>
    </button>
  )
}

export default TradingNavButton
